import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=60a76dde&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=60a76dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a76dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a76dde')) {
      api.createRecord('60a76dde', component.options)
    } else {
      api.reload('60a76dde', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=60a76dde&scoped=true&", function () {
      api.rerender('60a76dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z8z8a6v8x0MO/JS/comp/PopupDialog.vue"
export default component.exports